export const KIND_LABELS: Readonly<Record<string, string>> = {
  day_reward: 'День орбиты',
  week_reward: 'Неделя серии',
  task_reward: 'Задания',
  merge_carry: 'Перенос при слиянии',
  topup: 'Пополнение',
  topup_refund: 'Возврат пополнения',
  reading_purchase: 'Разбор',
  reading_refund: 'Возврат за разбор',
  reading_upgrade: 'Доплата за консультацию',
  extra_pick: 'Доп. карта дня',
  gift_purchase: 'Подарок',
  gift_refund: 'Возврат за подарок',
  day_repair: 'Ремонт серии',
}

export const PROMO_KIND_LABELS: Readonly<Record<string, string>> = {
  grant: 'Начислено',
  revoke: 'Списано',
  gift_purchase: 'Подарок',
  gift_refund: 'Возврат за подарок',
}

export const PROVIDER_LABELS: Readonly<Record<string, string>> = {
  yookassa: 'ЮKassa',
  telegram_stars: 'Telegram Stars',
  apple_iap: 'Apple IAP',
  google_play: 'Google Play',
}

export const CURRENCY_LABELS: Readonly<Record<string, string>> = { RUB: '₽', XTR: 'XTR' }

export const PAYMENT_STATUS_LABELS: Readonly<Record<string, string>> = {
  pending: 'Ожидает',
  paid: 'Оплачено',
  refunded: 'Возврат',
  failed: 'Ошибка',
}

export const CHECK_LABELS: Readonly<Record<string, string>> = {
  negative_balance: 'Отрицательный баланс',
  payment_without_credit: 'Оплата без начисления',
  credit_without_payment: 'Начисление без оплаты',
  refund_without_debit: 'Возврат без списания',
  topup_amount_mismatch: 'Сумма не равна пакету',
  free_over_rules: 'Бесплатные не по правилам',
  free_daily_cap: 'Кап бесплатных в сутки',
  sign_mismatch: 'Знак суммы не по типу',
  stuck_payment: 'Оплата зависла',
  expired_gift_no_refund: 'Подарок истёк без возврата',
  merge_carry_large: 'Большой перенос при слиянии',
  balance_spike: 'Скачок баланса',
}

export const FLAG_LABELS: Readonly<Record<string, string>> = {
  negative: 'Отрицательный',
  large: 'Крупный',
  free_large: 'Много бесплатных',
}

const DATE_TIME = new Intl.DateTimeFormat('ru-RU', {
  timeZone: 'Europe/Moscow',
  day: 'numeric',
  month: 'short',
  hour: '2-digit',
  minute: '2-digit',
})

export function formatDateTime(iso: string | null): string {
  return iso ? DATE_TIME.format(new Date(iso)) : '—'
}

export const RECEIPT_STATUS_LABELS: Readonly<Record<string, string>> = {
  todo: 'Оформить',
  issued: 'Оформлен',
  cancel_todo: 'Аннулировать',
  canceled: 'Аннулирован',
  none: 'Не нужен',
}

const RECEIPT_DATE = new Intl.DateTimeFormat('ru-RU', { timeZone: 'Europe/Moscow', day: '2-digit', month: '2-digit', year: 'numeric' })

export function formatReceiptDate(iso: string | null): string {
  return iso ? RECEIPT_DATE.format(new Date(iso)) : '—'
}

export function shortId(id: string): string {
  return id.length > 10 ? `${id.slice(0, 8)}…` : id
}
